"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISavingsVault__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "depositCap",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "depositFill",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
        ],
        name: "DepositCapExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "DepositForbidden",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxDeposit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxMint",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxRedeem",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "max",
                type: "uint256",
            },
        ],
        name: "ERC4626ExceededMaxWithdraw",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawnFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "InitializedAlready",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "decimals",
                type: "uint8",
            },
        ],
        name: "InvalidDecimals",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "InvalidDepositTimeRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "InvalidStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
        ],
        name: "InvalidWithdrawableTime",
        type: "error",
    },
    {
        inputs: [],
        name: "MoveForbidden",
        type: "error",
    },
    {
        inputs: [],
        name: "MovedAlready",
        type: "error",
    },
    {
        inputs: [],
        name: "NoReward",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
        ],
        name: "NonexistentStableCoin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInDepositPeriod",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "beginTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "currentTime",
                type: "uint256",
            },
        ],
        name: "NotInWithdrawPeriod",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyFactory",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferForbidden",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IStableCoin",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "decimals",
                type: "uint256",
            },
        ],
        name: "CoinAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IStableCoin",
                name: "coin",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "Deposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IERC20",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "EmergencyWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "assets",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "shares",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                internalType: "contract IStableCoin[]",
                name: "_coins",
                type: "address[]",
            },
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
        ],
        name: "constructor2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class ISavingsVault__factory {
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.ISavingsVault__factory = ISavingsVault__factory;
